<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BkhWhd/tc-custom/9781623807702.jpg?1716906082187" alt="This image is the cover for the book Horizonte, Horizonte"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Horizonte, Horizonte
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Buch 1 in der Serie - Horizonte</i></b></p><p>Der College-Footballspieler Clark Stevens, ein beliebter Wide Receiver mit Aussicht auf einen Vertrag in der NFL, hat eine Menge Probleme. Er hat eine eifersüchtige Freundin, einen engstirnigen und herrschsüchtigen Vater, eine Aufmerksamkeitsstörung, und er verspürt eine unerwartete, starke Anziehung zu dem Notarzt – dem männlichen Notarzt – der ihn wegen eines gebrochenen Arms behandelt.</p> <p>Dr. Jody Williams empfängt widersprüchliche Signale. Er kann nicht ignorieren, wie sehr er sich zu Clark hingezogen fühlt, denn es ist offensichtlich, dass Clark ebenso empfindet. Für den stolzen, geouteten Arzt ist die Lösung denkbar einfach. Für Clark ist sie das nicht. Seine Welt ist alles andere als schwulenfreundlich und die Hindernisse, denen er sich gegenübersieht, ließen ihn seine Sexualität viele Jahre lang verleugnen.</p> <p>Es ist der Superbowl der Katastrophen, egal, wie man es dreht und wendet. Am Ende muss Clark entscheiden, ob er an dem Leben festhält, das er kennt, oder ob er es riskiert, ein neues mit Jody zu beginnen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mickie B. Ashling, Jutta Grobleben
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?347c9afa